export enum SignupMethods {
  EMAIL = 'Email',
  GOOGLE = 'Google',
  FACEBOOK = 'Facebook'
}
